// 분배금 현황 API (/api/dividend-status)
import axiosInstance from './axiosInstance';

// 분배금 현황 조회 (당해연도 + 전년도 비교)
// params: { year, account_name?, include_interest }
export const fetchDividendStatus = async (params) => {
  const res = await axiosInstance.get('/dividend-status', { params });
  return res.data;
};

// 연도별 합계 조회 (툴바 표시용)
// params: { year, account_name?, include_interest }
export const fetchDividendStatusSummary = async (params) => {
  const res = await axiosInstance.get('/dividend-status/summary', { params });
  return res.data;
};
